module.exports = __webpack_public_path__ + "img/mobile-phones.41fd3e40.png";